import { render } from "./EditDemandePrix.vue?vue&type=template&id=5e5e0bdf&scoped=true&ts=true"
import script from "./EditDemandePrix.vue?vue&type=script&lang=ts"
export * from "./EditDemandePrix.vue?vue&type=script&lang=ts"

import "./EditDemandePrix.vue?vue&type=style&index=0&id=5e5e0bdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5e0bdf"]])

export default __exports__